module.exports = __webpack_public_path__ + "img/02-3.326c7b9a.png";